import moment from "moment";
import i18n from '@/locales';
export default{
    methods: {
        markUnsavedJobs() {
            this.arrowArray = [];
            for (let packet of this.cronPackets) {
              this.arrowArray.push("el-icon-caret-right");
              // console.log(packet);
              for (let job of packet.jobs) {
                // console.log(job.tpDate, job.tpName);
                // console.log(job);
                // console.log(this.cronTemplates);
                let template = this.cronTemplates.find(
                  (tmp) => tmp.name === job.tpName
                );
                // console.log(template);
                if(!template){
                  this.$message.error(i18n.t("templates.noTemplateFound") + ": " + job.tpName);
                  console.error("ERROR", packet, job, this.cronTemplates);
                  break;
                }
                let dateTemplate = moment(template.dateSave, "YYYY-MM-DD HH:mm:ss");
                let dateJob = moment(job.tpDate, "YYYY-MM-DD HH:mm:ss");
                if (
                  dateTemplate.isAfter(dateJob) &&
                  dateTemplate.isValid() &&
                  dateJob.isValid()
                ) {
                  // console.log("NOT SAVED", template, job);
                  job.notSync = true;
                  packet.notSync = true;
                  template.notSync = true;
                }
              }
            }
          },
    }
}